/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';

export const ItemBrowserGridEmptyDisplay: React.FC<ItemBrowserGridEmptyDisplayProps> = ({
  message
}) => (
  <div className="ItemBrowserGridEmptyDisplay tw-absolute tw-inset-0">
    <div className="ItemBrowserGridEmptyDisplay__placeholder tw-mx-auto tw-my-52 tw-flex tw-h-52 tw-w-52 tw-flex-col tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-200 tw-text-center tw-text-xs tw-text-gray-100 sm:tw-my-24 sm:tw-h-[400px] sm:tw-w-[400px] sm:tw-text-2xl">
      <i className="ItemBrowserGridEmptyDisplay__icon fa fa-cloud-upload-alt tw-pb-1 tw-text-3xl sm:tw-pb-2 sm:tw-text-6xl" />
      {message}
    </div>
  </div>
);

export interface ItemBrowserGridEmptyDisplayProps {
  /** The empty message for the body */
  message?: string;
}

export default ItemBrowserGridEmptyDisplay;
